"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.displayPropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _utils = require("../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var displayPropType = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.objectOf(_propTypes.default.string)]);

var displayPropTypes = {
  display: displayPropType,
  visibility: displayPropType
};
exports.displayPropTypes = displayPropTypes;

var _default = (0, _styledComponents.css)(["", ";", ";"], (0, _utils.applyDynamicModifiers)('display'), (0, _utils.applyDynamicModifiers)('visibility'));

exports.default = _default;